import { render, staticRenderFns } from "./rateDialog.vue?vue&type=template&id=856639a8&scoped=true&"
import script from "./rateDialog.vue?vue&type=script&lang=js&"
export * from "./rateDialog.vue?vue&type=script&lang=js&"
import style0 from "./rateDialog.vue?vue&type=style&index=0&id=856639a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856639a8",
  null
  
)

export default component.exports